<template>
  <div>
    <div>
      <!-- page meta -->
      <Head>
        <title>Subscriber Membership Software by Platforma</title>
        <link
          rel="icon"
          :href="$filters.public_path('favicon.png')"
          type="favicon"
        />
        <meta
          name="description"
          content="Monetize your social media followers with the #1 Subscriber software online"
        />
      </Head>
    </div>
    <!-- content start -->

    <div
      class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
    >
      <!-- ===================== HERO SECTION == =================== -->

      <section
        id="section1"
        class="hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
        :style="backgroundImageStyleMain"
      >
        <div class="mt-0 bg-transparent px-[25px] xl:px-0">
          <h1
            class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Build, nurture, and monetize your fan community.
          </h1>

          <p
            class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
          >
            Map your vision and sprint to market with Platforma's all-in-one
            content management platform.
          </p>

          <!-- captcher email widget -->
          <EmailCaptureHeaderWidget />

          <img :src="$filters.media_path('/images/stars.svg')" alt="" />
        </div>

        <div class="mb-[30px] mt-[30px] py-5 lg:mt-0 px-2 z-10">
          <video
            loop
            muted
            autoplay
            class="lazy rounded-3xl shadow-lg outline-none"
            id="home_video"
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/social-group-newsfeed-on-your-domain-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <div
        class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
      >
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
        <h2
          class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
        >
          JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
        </h2>
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      </div>

      <!-- ===================== FEEDS SECTION===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="$filters.media_path('/images/blue_gradient.svg')"
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div id="text_feeds" class="text-xs font-extrabold text-[#2D8CFF]">
              FEEDS
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Post news important to your group without inhibition.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Quit devaluing content by posting your best stuff on Facebook,
              Twitter, and the like. Make bank on your own site, by holding and
              monetizing exclusive content reserved for paying members.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <img
              loading="lazy"
              class="lg:w-[675px]"
              :src="
                $filters.media_path(
                  '/images/social-posts-in-your-members-course.png'
                )
              "
              alt="Your most important posts in a VIP membership site for members to freely access."
            />
          </div>
        </div>
      </section>

      <!-- ===================== CENSORSHIP SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[300px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
      >
        <img
          class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
          :src="$filters.media_path('/images/green-diamond-dots-bg.svg')"
          alt=""
        />

        <div
          class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
        >
          <div
            id="text_direct_line"
            class="text-xs font-extrabold text-[#27AE60] lg:left-0"
          >
            OUTSMART CENSORSHIP
          </div>

          <h2
            class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            The only<br />
            censor-free video channel.
          </h2>

          <div class="">
            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
            />
          </div>

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Youtube demonetizes, shadow bans, and terminates accounts everyday.
            Don’t be subject to the risk. Build your platform out where it can’t
            be canceled.
          </p>
        </div>

        <div
          class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
        >
          <video
            loop
            muted
            autoplay
            class="lazy rounded-3xl shadow-lg"
            id="home_video"
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/youtube-alternative-on-your-own-website-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <!-- ===================== SHOPIFY INTEGRATION SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[250px] lg:flex lg:h-[550px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="
            $filters.media_path('/images/platforma_turqoise_diamond_bg.svg')
          "
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div
              id="text_breaking_news"
              class="text-xs font-extrabold text-[#49CCF9]"
            >
              SHOPIFY INTEGRATION
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Make it easy for followers to buy your merch.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#49CCF9] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Connect your Shopify store and Platforma draws in all your
              physical products so subscribers can checkout right in the app.
              Orders drop right in to Shopify dashboard for fulfillment.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <img
              loading="lazy"
              class="lg:w-[645px]"
              :src="
                $filters.media_path(
                  '/images/sell-physical-products-to-subscribers-on-own-website.png'
                )
              "
              alt="Newsfeed in your own membership site."
            />
          </div>
        </div>
      </section>
    </div>
    <!-- ===================== CTA BLOCK ===================== -->
    <CtaBlock
      cta-headline="Consolidate your content &
make more money guaranteed."
    />
  </div>
</template>
<!-- =======CONTENT END======== -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    // ButtonComponent,
    EmailCaptureHeaderWidget,
    CtaBlock
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
